module.exports = __webpack_public_path__ + "img/ccl_gallery12.dfec7431.jpg";